import request from '../untils/request';

export const basicExpressListApi = params => {
  return request({
    url: '/basic/express/index',
    authCode:'EXPRESS_INDEX',
    params,
  });
};

export const basicGetProvincesApi = params => {
  return request({
    url: '/basic/express/express-area-list',
    params,
  });
};

export const basicExpressDetailApi = params => {
  return request({
    url: '/basic/express/detail',
    params,
  });
};

export const basicExpressSetDefaultApi = params => {
  return request({
    url: '/basic/express/set-recommend',
    params,
  });
};

export const basicExpressDeleteApi = params => {
  return request({
    url: '/basic/express/delete',
    params,
  });
};

export const basicExpressSaveApi = params => {
  return request({
    url: '/basic/express/save',
    params,
  });
};

export const basicKeywordsApi = params => {
  return request({
    url: '/basic/keyword/index',
    params,
  });
};

export const basicKeywordSaveApi = params => {
  return request({
    url: '/basic/keyword/save',
    params,
  });
};

export const basicKeywordDeleteApi = params => {
  return request({
    url: '/basic/keyword/delete',
    params,
  });
};

export const basicBanksApi = params => {
  return request({
    url: '/basic/bank/index',
    authCode:'BANK_INDEX',
    params,
  });
};

export const basicBankSaveApi = params => {
  return request({
    url: '/basic/bank/save',
    params,
  });
};

export const basicBankDeleteApi = params => {
  return request({
    url: '/basic/bank/delete',
    params,
  });
};


export const basicAccountDeleteApi = params => {
  return request({
    url: '/basic/bank-account/delete',
    params,
  });
};


export const basicAccountSaveApi = params => {
  return request({
    url: '/basic/bank-account/save',
    params,
  });
};


export const basicAccountApi = params => {
  return request({
    url: '/basic/bank-account/index',
    params,
  });
};

export const basicPaySaveApi = params => {
  return request({
    url: '/basic/pay/save',
    params,
  });
};


export const basicPayInfoApi = params => {
  return request({
    url: '/basic/pay/detail',
    params,
  });
};

export const basicAppMchApi = params => {
  return request({
    url: '/basic/pay/app-mch',
    params,
  });
};

export const basicCmchApi = params => {
  return request({
    url: '/basic/pay/c-mch',
    params,
  });
};

export const basicMiniMchApi = params => {
  return request({
    url: '/basic/pay/mini-mch',
    params,
  });
};

export const basicSettingApi = params => {
  return request({
    url: '/basic/setting/index',
    params,
  });
};

export const basicSettingSaveApi = params => {
  return request({
    url: '/basic/setting/save',
    params,
  });
};

export const basicSettingOperateApi = params => {
  return request({
    url: '/basic/setting/operate',
    params,
  });
};

export const basicSettingDetailApi = params => {
  return request({
    url: '/basic/setting/detail',
    params,
  });
};

export const basicTemplatesApi = params => {
  return request({
    url: '/basic/message-template/index',
    params,
  });
};

export const basicTemplateSaveApi = params => {
  return request({
    url: '/basic/message-template/save',
    params,
  });
};

export const basicTemplateOperateApi = params => {
  return request({
    url: '/basic/message-template/operate',
    params,
  });
};

export const basicTemplateClassListApi = params => {
  return request({
    url: '/basic/message-template/classify',
    params,
  });
};


export const questionnaireListApi = params => {
  return request({
    url: '/system/exam/exam-list',
    params,
  });
};

export const questionnaireSaveApi = params => {
  return request({
    url: '/system/exam/save',
    params,
  });
};

export const questionnaireOperateApi = params => {
  return request({
    url: '/system/exam/operate-exam',
    params,
  });
};